import View from "../view";
import { RiskConfiguration } from "./riskConfiguration";
import { NavConfiguration } from "./navConfiguration";
import { NavItemConfiguration } from "./navItemConfiguration";
import { AssetOptions } from "./assetOptions";
import AnnuityType from "../annuityType";
import { WorkflowConfiguration } from "./workflowConfiguration";
import KeyValue from "../common/keyValue";
import { FooterConfiguration } from "./footerConfiguration";
import AccountRegistrationBehaviour from "../accountRegistrationBehaviour";
import AdviserListDisplayMode from "../adviserListDisplayMode";

class Configuration {
  public constructor() {
    this.activeView = 1;
    this.monitor = false;
    this.gaKey = "";
    this.hotjarSiteId = "";
    this.dashboardShowCurrentContributionHelp = false;
    this.guaranteedIncomeEnabled = false;
    this.assetOptions = {
      pensionPots: false,
      finalSalary: false,
      savings: false,
      otherIncome: false,
      otherCash: false
    } as AssetOptions;
    this.nav = {
      home: {} as NavItemConfiguration,
      start: {} as NavItemConfiguration,
      design: {} as NavItemConfiguration,
      track: {} as NavItemConfiguration,
      login: {} as NavItemConfiguration
    } as NavConfiguration;
  }

  activeView: View;
  section: string;
  subSection: string;
  monitor: boolean;
  aiInstrumentationKey: string;
  gaKey: string;
  gtagTrackingId: string;
  adwordsId: string;
  hotjarSiteId: string;
  disconnected: boolean;
  companyFullName: string;
  companyAbbrevName: string;
  parentCompanyLink: string;
  olarkEnabled: boolean;
  requestCookieConsent: boolean;
  anonRedirect: string;
  title: string;
  displayTitleInWorkflow: boolean;
  customHelpIcon: string;
  dashboardShowCurrentContributionHelp: boolean;
  designShowRiskHelp: boolean;
  mainJourneyReferenceText: string;
  userHomeTrackIntroTitle: string;
  userHomeTrackIntroText: string;
  userHomeMainJourneyIntroText: string;
  guaranteedIncomeEnabled: boolean;
  guaranteedIncomeSuppliersHidden: boolean;
  annuityType: AnnuityType;
  canLinkLiveValuesFromHaves: boolean;
  canLinkLiveValuesFromDashboard: boolean;
  liveValuesLinkMoreFundsAdviceText: string;
  workflowShowsRetirementAge: boolean;
  retirementDateReadOnly: boolean;
  solveIncludesEquityRelease: boolean;
  taxFreeCashOptions: Array<string>;
  havesSubHeadingText: string;
  havesPensionPotsListHeaderText: string;
  havesFinalSalaryListHeaderText: string;
  requirementsExpenseEditPriviledges: boolean;
  showTermsOfUse: boolean;
  termsOfUseResource: string;
  showTrustpilot: boolean;
  showPoweredBy: boolean;
  disclaimer: string;
  allowsSignup: boolean;
  signupBehaviour: AccountRegistrationBehaviour;
  signupPrompt: string;
  signupButtonText: string;
  signupMotivationDisplayed: boolean;
  signupCompletedMessage: string;
  finishDisplaysNextButton: boolean;
  finishDisplaysProviders: boolean;
  finishDisplaysAdvisors: boolean;
  finishDisplaysPensionBeeSeparately: boolean;
  finishDisplaysOtherOptions: boolean;
  finishDisplaysCharges: boolean;
  finishDisplaysChargesExtraMessage: string;
  finishDisplaysChargesShowsPotCnsldnMsg: boolean;
  finishDisplaysAnnuity: boolean;
  finishDisplaysFinancialAdvice: boolean;
  finishDisplaysGenericCostOfFinancialAdvice: boolean;
  finishDisplaysOptionsNowYouHaveAPlan: boolean;
  finishDisplaysGuiideMarketing: boolean;
  finishCanViewPlanWithoutSignup: boolean;
  finishCanDownloadReport: boolean;
  finishBespokeRiskWarnings: string;
  providersLinkForII: string;
  providersShowsRetailers: boolean;
  adviserListTitle: string;
  adviserListDisplayMode: AdviserListDisplayMode;
  guiidePlusAdvisersShowsAdviceReasons: boolean;
  assetOptions: AssetOptions;
  risk: RiskConfiguration;
  solveIncPaymentsConfirmText: string;
  nav: NavConfiguration;
  workflow: WorkflowConfiguration;
  secureProductApplyActive: boolean;
  additionalInfo: Array<KeyValue>;
  footer: FooterConfiguration;

  public static getCssVariableValue(variableName: string): string {
    const styles = getComputedStyle(document.documentElement);
    return styles.getPropertyValue(variableName);
  }
}

const configuration = new Configuration();

export { Configuration, configuration };
